import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import { VendorBills } from "@/components/admin/VendorBills";
import { VendorList } from "@/components/admin/VendorList";

export default function AdminVendors() {
    const [tab, setTab] = useState("bills");
    const [bills, setBills] = useState(null);
    const [vendors, setVendors] = useState([]);
    const load = useCallback(() => {
        api.get("/admin/vendor-bills").then((r) => setBills(r.data)).catch(() => setBills([]));
        api.get("/admin/vendors").then((r) => setVendors(r.data)).catch(() => setVendors([]));
    }, []);
    useEffect(() => { load(); }, [load]);
    const pending = vendors.filter((v) => v.status !== "APPROVED").length;
    return (
        <div>
            <h1 className="font-heading text-2xl font-extrabold text-navy">Vendors</h1>
            <p className="text-sm text-navy/55">Material bills paid directly to vendors · HOMIIE margin 10% + 5% GST is deducted from each vendor payment</p>
            <div className="mt-4 inline-flex rounded-full bg-navy/5 p-1">
                {[["bills", "Material bills"], ["list", `Vendor list${pending ? ` (${pending} pending)` : ""}`]].map(([k, l]) => (
                    <button key={k} data-testid={`vtab-${k}`} onClick={() => setTab(k)} className={`rounded-full px-5 py-2 text-sm font-bold transition-colors ${tab === k ? "bg-orange text-white" : "text-navy/60"}`}>{l}</button>
                ))}
            </div>
            {bills === null ? <div className="flex justify-center py-16"><Loader2 className="h-7 w-7 animate-spin text-orange" /></div>
                : tab === "bills" ? <VendorBills rows={bills} vendors={vendors} onChanged={load} /> : <VendorList vendors={vendors} onChanged={load} />}
        </div>
    );
}
